module.exports = __webpack_public_path__ + "22222da0ef30c62ed8ce1c2f68523af9.fbx";